/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://b9kmfttf4k.execute-api.us-east-2.amazonaws.com/hyattjedda",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://fumvbv62m5cjtkaktxdp6qa3xu.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-s4sks3cokfbp3enzzed3m2uhru",
    "aws_cognito_identity_pool_id": "us-east-2:2131ded6-7549-4542-9e00-ca410d6b3db2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_h05ILOC62",
    "aws_user_pools_web_client_id": "242lc0t42chlset84uhrc43rp8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
